import React from 'react';

const CouponItem = (props) => {
    const { data, onActiveId } = props;
    return (
            <div data-v-35afea22="" className="box_coupon m-t-12px mb-4 mr-4 mt-4 ml-4">
                <div className="position-relative" data-v-35afea22="" onClick={() => onActiveId(data._id)}>
                  <div data-v-35afea22="" className="lottery_result">
                      <strong className="h-100- padding-15px-top- d-block line-height-2 " style={{ textAlign: "center" }}>
                          쿠폰명: {data.name}
                          <br />
                          <span className="font-size-1 line-height-1 font-weight-400">{data.type}</span>
                          <br />
                          <span className="font-size-1 line-height-1 font-weight-400">{data.startTime} ~ {data.endTime}</span>
                          <br />
                          <span className={`font-size-1 line-height-1 font-weight-400 `}>
                          {data.amount}
                          </span>
                      </strong>
                  </div>
                </div>
            </div>
    );
}
export default CouponItem;


// WEBPACK FOOTER //
// ./src/components/account/CouponItem.js